import { GlobalRole } from '@itm/shared-frontend';

import { isAzureTargetPlatform } from 'src/utils/constants';

import { Role } from 'src/types';

// Reusable role groups — the single source of truth for every route's
// allowList. Both `RootRouter` (route guards) and `Sidebar` (menu config)
// must read from `routeAccess` so the guard and the menu can never drift.
//
// Flat groups are consumed by `GuardedRoute` (which expects Role[]) and by
// `Sidebar`. Nested groups (Role | GlobalRole[]) are Sidebar-only — the
// Navigation component treats a nested array as "any one of these roles".
const ANALYST_UP: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst];
const MIGRATION_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst];
const ONBOARDING_ROUTE_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin];
const SUPER_SUPPORT: Role[] = [Role.SuperAdmin, Role.Support];

const TRANSLATIONS_ADMINS: (Role | GlobalRole[])[] = [
  Role.SuperAdmin,
  Role.Support,
  [GlobalRole.DataTransformation_Analyst, GlobalRole.DashboardISP_Analyst],
];
const ONBOARDING_ADMINS: (Role | GlobalRole[])[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.ClientAdmin,
  [GlobalRole.DataTransformation_Analyst, GlobalRole.DataAudit_Analyst],
];

// Per-property type inference: flat entries infer Role[], conditional/nested
// entries infer (Role | GlobalRole[])[]. GuardedRoute consumers reference only
// the flat entries, so no casts are needed.
export const routeAccess = {
  // Guards (consumed by RootRouter) — flat Role[]
  migrationRoot: MIGRATION_ADMINS,
  migrationMasterTemplates: ANALYST_UP,
  migrationDataDictionary: ANALYST_UP,
  translationsMappings: ANALYST_UP,
  translationsMasterTemplates: ANALYST_UP,
  onboardingRoot: ONBOARDING_ROUTE_ADMINS,

  // Sidebar — flat Role[]
  additionalOptionsRoot: ANALYST_UP,
  additionalOptionsProductInfoRoot: SUPER_SUPPORT,
  masterTemplatesRoot: ANALYST_UP,
  masterDataDictionaryRoot: ANALYST_UP,
  onboardingConfigurationCreateRoot: ANALYST_UP,
  onboardingMasterTemplatesRoot: ANALYST_UP,
  onboardingMasterDataDictionaryRoot: ANALYST_UP,

  // Sidebar — conditional / nested (Role | GlobalRole[])[]
  // On Azure the translations & onboarding sections are hidden (empty allowList).
  translationsRoot: isAzureTargetPlatform ? [] : TRANSLATIONS_ADMINS,
  onboardingSidebar: isAzureTargetPlatform ? [] : ONBOARDING_ADMINS,
};
